// dependancys
import React, { useState, useEffect, useGlobal } from "reactn";
import PropTypes from "prop-types";

// components
import FormTemplate from "../../../_common/templates/FormTemplate";
import { AddNewAddressConfig } from "./AddNewAddress.config";
import Loader from "shared-anpost-components/components/loader/Loader";
import GlobalError from "shared-anpost-components/components/globalError/GlobalError";

// hooks
import addressHooks from "../../../../hooks/addressHooks";
import AppHook from "../../../../hooks/appHook";

// APIs
import { addAddress, createAutoDib, getJWTInfo, getProfile, updateAutoDib } from "../../../../services/Api";

import { pushDataLayer, virtualPageView } from "../../../../helpers/Helpers";

const EditAddress = ({ history, addressConfig, backupInfo, selectedAddressId, toUpdate, onError }) => {
    const [loader, setLoader] = useState(false);
    const [apiError, setApiError] = useState(false);
    const [refetch, setRefetch] = useGlobal("refetch");

    const { values, getAddress } = addressHooks();
    const hook = AppHook();

    const handleError = () => {
        setLoader(false);
        onError(true);
        setApiError(true);
    };

    // push to next route
    const nextStep = () => {
        setLoader(true);

        // Get the Address data
        const addressData = getAddress("personalAddress", values, { ciamAPI: true });

        let managerType;
        let managerInstructions;

        if (hook.values["addressBackup"] === "safespot" || hook.values["addressBackup"].value === "safeSpot") {
            managerType = "1";
            managerInstructions = hook.values["safespotDescription"];
        } else if (hook.values["addressBackup"] === "neighbour") {
            managerType = "3";
            managerInstructions = `${hook.values["neighboursName"]}, ${hook.values["neighboursAddress"]}`;
        }

        if (toUpdate !== null) {
            updateAutoDib(values.ciamUserId, {
                groupId: toUpdate.groupId,
                addressId: toUpdate.addressId,
                deliveryManagerType: managerType,
                instruction: managerInstructions
            }).finally(() => {
                pushDataLayer({
                    event: "delivery_backup",
                    backup_type: managerType === "1" ? "Safe Spot" : "Neighbour"
                });
                setLoader(false);
                setRefetch(!refetch);
            });
            return;
        }

        // Add address
        if (backupInfo) {
            createAutoDib(values.ciamUserId, {
                addressId: selectedAddressId,
                deliveryManagerType: managerType,
                instruction: managerInstructions
            }).then(d => {
                pushDataLayer({
                    event: "delivery_backup",
                    backup_type: managerType === "1" ? "Safe Spot" : "Neighbour"
                });
                setLoader(false);
                setRefetch(!refetch);
            });
        } else {
            getJWTInfo().then(() => {
                addAddress(addressData)
                    .then(res => {
                        if (res.status === 200) {
                            hook.setIndividualValue("refreshDeliveryInstructions", true);
                            getProfile(values.ciamUserId).then(res => {
                                if (res.status === 200) {
                                    sessionStorage.setItem("userProfile", JSON.stringify(res.data));
                                }
                            });
                        } else {
                            handleError();
                        }
                        return res.data;
                    })
                    .then(data => {
                        createAutoDib(values.ciamUserId, {
                            addressId: data.id,
                            deliveryManagerType: managerType,
                            instruction: managerInstructions
                        }).then(() => {
                            pushDataLayer({
                                event: "delivery_backup",
                                backup_type: managerType === "1" ? "Safe Spot" : "Neighbour"
                            });
                            setRefetch(!refetch);
                            setLoader(false);
                        });
                    })
                    .catch(() => {
                        handleError();
                    });
            });
        }
    };

    useEffect(() => {
        virtualPageView("/myAccount/myDeliveries/DeliveryBackup/Add-an-address", "MyDeliveries Account - Delivery Backup - Add an address");
    }, []);

    return (
        <>
            {loader && <Loader />}
            {apiError && <GlobalError />}
            <FormTemplate config={addressConfig} nextStep={nextStep}>
                {" "}
            </FormTemplate>
        </>
    );
};

export default EditAddress;
EditAddress.propTypes = {
    history: PropTypes.object
};
